"use client";
import { useContext, useEffect } from "react";
import { AppContext } from "@/context/AppContext";

const AstroHackAdPopupTrigger = () => {
  const { setPopups } = useContext(AppContext) ?? {};

  useEffect(() => {
    setPopups && setPopups({ showAstroHackPopup: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default AstroHackAdPopupTrigger;
